import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TournamentService } from '../../../../services/tournament.service';
import { ImgService } from '../../../../services/img.service';

@Component({
  selector: 'map-game-table',
  templateUrl: 'map-game-table.html',
})
export class MapGameTablePage {
  gamePlanList: IGamePlan[] = [];
  numerators = [];
  isMobile: boolean = true;

  @Input() activePlan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  constructor(
    private navParams: NavParams,
    public gs: TournamentService,
    public loadCtrl: LoadingController,
    private imgService: ImgService,
    private navCtrl: NavController
  ) { 
    let loader = this.loadCtrl.create({});
    loader.present();
    this.determinePlatform();
    setTimeout(() => {
      this.getNumerator();
      loader.dismiss();
    }, 300);
  }

  getNumerator() {
    let id = 1;
    for (let i = 0; i < this.gs.planList[this.activePlan].gameTable.length; i++) {
      let table = [];
      for (let j = 0; j < this.gs.planList[this.activePlan].gameTable[i].length; j++) {
        table.push(id);
        id += 1;
      }
      this.numerators.push(table);
    }
  }

  determinePlatform(){
    let width = window.innerWidth;
    if(width > 600){
      this.isMobile = false;
    }
  }

  onEditTeam(i: number, j: number) {
    if(!this.gs.planList[this.activePlan].gameTable[i]) return;
    this.onEdit.emit({ i: i, j: j });
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-ko/map-game-table/map-game-table.ts